import { Outlet, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { Sidebar } from './Sidebar';
import { Topbar } from './Topbar';
import { RightPanel } from './RightPanel';
import { useSidebarStore } from '@/lib/stores';
import { useAuthStore } from '@/lib/auth';
import { useEffect, useState } from 'react';

const pageVariants = {
  initial: { opacity: 0, y: 8 },
  animate: { opacity: 1, y: 0, transition: { duration: 0.35, ease: [0.2, 0.8, 0.2, 1] } },
  exit: { opacity: 0, y: -6, transition: { duration: 0.2 } },
};

export function AppShell() {
  const { collapsed } = useSidebarStore();
  const { user } = useAuthStore();
  const location = useLocation();
  const isWorkspace = location.pathname.includes('/app/project/');
  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 1024);

  useEffect(() => {
    const onResize = () => setIsDesktop(window.innerWidth >= 1024);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  // On desktop: offset by sidebar width. On mobile: full width (0).
  const marginLeft = isDesktop ? (collapsed ? 64 : 260) : 0;

  return (
    <div className="min-h-screen bg-background">
      <Sidebar userRole={user?.role} />

      <div
        style={{ marginLeft }}
        className="transition-[margin-left] duration-200 ease-[cubic-bezier(0.2,0.8,0.2,1)]"
      >
        <Topbar showPanelButtons={isWorkspace} />
        <main className="min-h-[calc(100vh-3.5rem)]">
          <AnimatePresence mode="wait">
            <motion.div
              key={location.pathname}
              variants={pageVariants}
              initial="initial"
              animate="animate"
              exit="exit"
            >
              <Outlet />
            </motion.div>
          </AnimatePresence>
        </main>
      </div>
      <RightPanel />
    </div>
  );
}
